import { ColumnMap } from 'src/app/domainObjects/columnMap';
import { DataFarmType } from './dataFarmType';
import { SortInfo } from './sortInfo';

export class DataTypeConverter {
    farmType: number;
    durationUnits: DurationUnits;
    runDataTypeConverter: boolean = false;
    ingestOnFail: boolean = false;

    constructor(farmType: number, durationUnits: DurationUnits, runDataTypeConverter: boolean, ingestOnFail: boolean) {
      this.farmType = farmType;
      this.durationUnits = durationUnits;
      this.runDataTypeConverter = runDataTypeConverter;
      this.ingestOnFail = ingestOnFail;
    }

    static fromJSON(data: any): DataTypeConverter {
      //console.log(`fromJson invoked: ${data}`);
      const instance: DataTypeConverter = Object.assign(new DataTypeConverter(0, 0, true, false), data);
      return instance;
    }

    toDataTypeConverter(): DataTypeConverter {
      return new DataTypeConverter(this.farmType, this.durationUnits, this.runDataTypeConverter,this.ingestOnFail);
    }
}

export class DurationBuilder {
  farmType: number;
  durationUnits: DurationUnits;
  eventStartField: string;
  eventEndField: string;
  durationField: string;
  runIngestDuration: boolean = false
  //sortInfo: SortInfo[];

  constructor(farmType: number, durationUnits: DurationUnits, eventStartField: string, eventEndField: string, durationField: string,runIngestDuration: boolean) {//,sortInfo: SortInfo[]
    this.farmType = farmType;
    this.durationUnits = durationUnits;
    this.eventStartField= eventStartField;
    this.eventEndField= eventEndField;
    this.durationField= durationField;
    this.runIngestDuration = runIngestDuration
    //this.sortInfo= sortInfo;
  }

  static fromJSON(data: any): DurationBuilder {
    //console.log(`fromJson invoked: ${data}`);
    const instance: DurationBuilder = Object.assign(new DurationBuilder(0, 0, '', '','',false), data);//,[]
    return instance;
  }

  toDurationBuilder(): DurationBuilder {
    return new DurationBuilder(this.farmType, this.durationUnits,this.eventStartField,this.eventEndField,this.durationField,this.runIngestDuration);//,this.sortInfo
  }
}
export class DeduplicateRows {
  farmType: number;
  removeDuplicateRow: boolean = false;
  whichRowKeep?: WhichRowKeep;

  constructor(farmType: number, removeDuplicateRow: boolean, whichRowKeep?: WhichRowKeep) {
    this.farmType = farmType;
    this.removeDuplicateRow = removeDuplicateRow;
    this.whichRowKeep = whichRowKeep;
  }

  static fromJSON(data: any): DeduplicateRows {
    //console.log(`fromJson invoked: ${data}`);
    const instance: DeduplicateRows = Object.assign(new DeduplicateRows(0, false, 0), data);
    return instance;
  }

  toDeduplicateRows(): DeduplicateRows {
    return new DeduplicateRows(this.farmType, this.removeDuplicateRow, this.whichRowKeep);
  }
}
export class GeneralParameter {
  farmType: number;
  threads: number;
  stringObjectDefVal: string;
  timestampDefVal: string;
  booleanDefVal: string;
  integerDefVal: string;
  floatDefVal: string;
  durationDefVal: string;
  rawDataDefault: string;

  constructor(farmType: number, threads: number, stringObjectDefVal: string, timestampDefVal: string, booleanDefVal: string, integerDefVal: string, floatDefVal: string, durationDefVal: string,rawDataDefault: string) {
    this.farmType = farmType;
    this.threads = threads;
    this.stringObjectDefVal = stringObjectDefVal;
    this.timestampDefVal = timestampDefVal;
    this.booleanDefVal = booleanDefVal;
    this.integerDefVal = integerDefVal;
    this.floatDefVal = floatDefVal;
    this.durationDefVal = durationDefVal;
    this.rawDataDefault = rawDataDefault;
  }

  static fromJSON(data: any): GeneralParameter {
    //console.log(`fromJson invoked: ${data}`);
    const instance: GeneralParameter = Object.assign(new GeneralParameter(0, 0, '', '', 'False', "", "", "0", ''), data);
    return instance;
  }

  toGeneralParameter(): GeneralParameter {
    return new GeneralParameter(this.farmType, this.threads, this.stringObjectDefVal, this.timestampDefVal, this.booleanDefVal, this.integerDefVal, this.floatDefVal, this.durationDefVal,this.rawDataDefault);
  }
}

export enum DurationUnits {
  m = 0,
  s = 1,
  ms = 2,
  us = 3,
  ns = 4,
}

export class DurationUnitsUtil {
  static toString(type: DurationUnits): string {
      switch (type) {
          case DurationUnits.m:
              return 'minutes(m)';
          case DurationUnits.s:
              return 'seconds(s)';
          case DurationUnits.ms:
              return 'milliseconds(ms)';
          case DurationUnits.us:
              return 'microseconds(µs)';
          case DurationUnits.ns:
              return 'nanoseconds(ns)';
      }
  }
}

export enum WhichRowKeep {
  keepfirst = 0,
  keeplast = 1,
  removeboth = 2
}

export class WhichRowKeepUtil {
  static toString(type: WhichRowKeep): string {
      switch (type) {
          case WhichRowKeep.keepfirst:
              return 'Keep first';
          case WhichRowKeep.keeplast:
              return 'Keep last';
          case WhichRowKeep.removeboth:
              return 'Remove both';
      }
  }
}
